import { useNewUserAccessRights } from '@app/hooks/useNewUserAccessRights';
import { accessRightsInitialState } from '@app/store/slices/AccessRights/constants';

// Права на медицинские документы (СЭМД/ЕГИСЗ): вкладка «Медкарта», реестр
// медкарт, подписание и отправка в РЭМД. Фолбэк на дефолты нужен для прав,
// сохранённых в localStorage до появления блока MedicalDocuments.
export const useMedicalDocumentsAccessRights = () => {
  const { userAccessRights } = useNewUserAccessRights();

  const medicalDocuments =
    userAccessRights.MedicalDocuments ??
    accessRightsInitialState.user.MedicalDocuments;

  return {
    hasUserRightToViewMedicalDocuments: medicalDocuments.IsOn,
    hasUserRightToEditMedicalDocuments: medicalDocuments.IsEdit,
    hasUserRightToSignMedicalDocuments: medicalDocuments.IsSign,
    hasUserRightToSendMedicalDocuments: medicalDocuments.IsSend,
    hasUserRightToViewAllMedicalDocuments: medicalDocuments.IsViewAll,
  };
};
